const privacyPlocy = {
  path: 'privacyPlocy',
  component: resolve => require(['../../../pages/privacyPlocy'], resolve)
}

export default privacyPlocy
